import { render, staticRenderFns } from "./One_Order_List.vue?vue&type=template&id=485b6068&scoped=true"
import script from "./One_Order_List.vue?vue&type=script&lang=js"
export * from "./One_Order_List.vue?vue&type=script&lang=js"
import style0 from "./One_Order_List.vue?vue&type=style&index=0&id=485b6068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485b6068",
  null
  
)

export default component.exports